export function createRoadFlow() {
 var ids=new WeakMap();
 function id(object){if(!ids.has(object))ids.set(object,crypto.randomUUID());return ids.get(object);}
 function none(){return {state:{kind:'',id:'',node:0,difficulty:0,ready:false},view:null};}
 function inspect(win,control,explore,h){
  var cur=explore&&explore.cur,cfg=cur&&cur.data;if(!cur||!cfg||!control||!control.hasNode||Number(control.hasNode.id)!==Number(cfg.id))return none();
  var registry=win.Laya.__classmap,stage=win.Laya.stage,node=Number(cfg.id),difficulty=Number(cfg.difficulty);
  if(!Number.isSafeInteger(node)||node<=0||![1,2].includes(difficulty))return none();
  var talkClass=registry['com.game.map.control.ExploreScreenTalkControl'],talkControl=talkClass&&(talkClass._ins||talkClass.ins),talk=talkControl&&talkControl.curSpawn;
  var viewClass=registry['com.game.movie.movieView.MovieScreenTalkPanel'],view=viewClass&&viewClass._ins;
  if(talk&&talk.m_onFinish&&talk.m_onFinish.caller===cur&&view&&Number(view._talkId)===Number(talk.m_talkId)&&h.panelOpen(view,stage)){
   return {state:{kind:'talk',id:id(talk)+':'+String(view.traceId||0)+':'+String(!!view.isLooping),node:node,difficulty:difficulty,ready:!!talkControl.canPlaying&&typeof view.onClick==='function'},view:view};
  }
  var eff=control.eff;
  if(eff&&Number(eff.id)===node&&eff.handler&&eff.handler.caller===cur&&h.panelOpen(eff,stage)){
   return {state:{kind:'confirm',id:id(cur)+':'+id(eff),node:node,difficulty:difficulty,ready:h.enabled(eff.btnStart,stage,eff)&&typeof eff.onClick==='function'},view:eff};
  }
  return none();
 }
 return {inspect:inspect};
}
